import React from 'react';
import './multi-content-highlights.module.scss';

import { SingleHighlight } from 'components/highlights/highlights-types';
import { SingleCounterHighlight } from '../SingleCounterHighlight';
import { useInView } from 'react-intersection-observer';

interface MultiContentHighlightsProps {
  highlights: SingleHighlight[]
}

export const MultiContentHighlights = ({
  highlights,
}: MultiContentHighlightsProps) => {
  const prefix: string = 'fr-mcb-highlights';

  const MODIFIERS_BY_COUNT: Record<number, string> = {
    2: `${prefix}__wrapper--two-children`,
    3: `${prefix}__wrapper--three-children`,
    4: `${prefix}__wrapper--four-children`,
  }

  const { ref, inView } = useInView({
    threshold: 0.3,
    triggerOnce: true,
  });

  const getWrapperModifier = (arraySize: number) => {
    if (arraySize <= 1) return '';
    if (arraySize > 1 && arraySize <= 4) {
      return MODIFIERS_BY_COUNT[arraySize];
    }
    if (arraySize > 4) {
      return MODIFIERS_BY_COUNT[4];
    }
  }

  const mcbWrapperModifier = getWrapperModifier(highlights.length);

  return (
    <div
      className={ `${prefix}__wrapper ${mcbWrapperModifier}` }
      ref={ ref }
    >
      { highlights.map(({ elements, id }) => {
        return (
          <SingleCounterHighlight
            baseClassName={ prefix }
            elements={ elements }
            inView={ inView }
            key={ id }
          />
        )
      }) }
    </div>
  )
}
